import { useAutoAnimate } from "@formkit/auto-animate/react";
import type { ReactNode } from "react";
import { duration } from "@bundle/tokens";

export type AnimatedListProps = {
  /** Keyed rows: one that's added, removed or moved animates, the others make way. Reduced motion: they just change. */
  children?: ReactNode;
  testID?: string;
};

/**
 * A column whose rows don't jump when a refresh changes them. iOS: `.animation(_:value:)` on the list; Android:
 * `Modifier.animateItem()`. Key it by the list shown, so another list replaces it instead of animating into it.
 */
export function AnimatedList({ children, testID }: AnimatedListProps) {
  const [ref] = useAutoAnimate<HTMLDivElement>({ duration: duration.normal, easing: "ease-out" });
  return (
    <div ref={ref} className="b-stack" data-testid={testID}>
      {children}
    </div>
  );
}
